// ABOUTME: The owner's view of production briefs (REST /production-briefs, the same view the
// brief card, an agent's row and Today's "In progress" read). Shapes mirror
// app/services/production_briefs/views.py (snake_case, no mapping layer); the status words and
// the link to the finished work come from that view.
import { api } from '@/api/client'

export type BriefState =
  | 'working'
  | 'queued'
  | 'completed'
  | 'waiting'
  | 'failed'
  | 'pending'
  | 'in_progress'

export interface BriefPreview {
  asset_id: string
  kind: string
  url: string | null
  thumbnail_url: string | null
}

export interface ProductionBrief {
  id: string
  kind: string
  status: string
  state: BriefState
  title: string
  role_name: string | null
  agent_role_id: string | null
  queue_position: number | null
  waiting_behind: { id: string; title: string } | null
  current_step: string | null
  last_error: string | null
  message_id: string | null
  conversation_id: string | null
  previews: BriefPreview[]
  /** Where it stands, in a few words: queued, working, waiting for the owner's answer, done. */
  status_line: string
  /** Where its finished work is (Library, Leads), when it has any. */
  link: { label: string; path: string } | null
  created_at: string | null
  completed_at: string | null
}

export const PRODUCTION_BRIEFS_KEY = 'production-briefs'
/** The open-brief list's key under PRODUCTION_BRIEFS_KEY. */
export const OPEN_BRIEFS = 'open'

export async function getProductionBrief(id: string): Promise<ProductionBrief> {
  return api.get<ProductionBrief>(`/production-briefs/${id}`)
}

export interface BriefAnswer {
  message_id: string
  conversation_id: string
  created_at: string
  /** The revision that takes the owner's answer to the team member. */
  revision_id: string
}

/** The owner's answer to a team member's post on a brief waiting for them: it goes to the member
 *  as a revision of the brief (POST /production-briefs/{id}/answer). */
export async function answerBrief(
  briefId: string,
  message: string,
  clientMessageId: string
): Promise<BriefAnswer> {
  return api.post<BriefAnswer>(`/production-briefs/${briefId}/answer`, {
    message,
    client_message_id: clientMessageId,
  })
}

/** Every open brief, oldest first: each role's queue order. */
export async function listOpenBriefs(): Promise<ProductionBrief[]> {
  return api.get<ProductionBrief[]>('/production-briefs', {
    params: { status: 'open' },
  })
}
